<template>
  <div class="post">
    <el-tabs v-model="params.status" @tab-click="handleClick">
      <template v-for="tab in tabs">
        <el-tab-pane :key="tab.key" :label="tab.text" :name="tab.key"></el-tab-pane>
      </template>
    </el-tabs>
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="8">
        <el-row align="top">
          <el-col :span="6" class="form-label">
            发布时间
          </el-col>
          <el-col :span="18">
            <el-date-picker
                size="small"
                v-model="created_time"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="7" :offset="resizeOffset" style="margin-bottom: 20px">
        <el-row align="top">
          <el-col :span="6" class="form-label">
            公司名称
          </el-col>
          <el-col :span="18">
            <el-input size="small" v-model="params.company_name" placeholder="请输入公司名称"></el-input>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="7">
        <el-row align="top">
          <el-col :span="6" class="form-label">
            发布方式
          </el-col>
          <el-col :span="18">
            <el-select size="small" v-model="params.releasemode" placeholder="请选择发布方式">
              <el-option
                  label="企业发布"
                  value="1">
              </el-option>
              <el-option
                  label="平台发布"
                  value="2">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row :gutter="24" justify="space-between">
      <el-col :span="12">
        <el-button type="primary" style="margin-right:12px;" @click="getData()">筛选</el-button>
        <el-button style="margin-right:12px;" @click="resetParams">清空筛选条件</el-button>
        <span>共找到 {{ total }} 条信息</span>
      </el-col>
      <el-col :span="12">
        <el-button
            type="primary"
            style="float:right;"
            @click="addPost"
        >+ 发布赚钱任务
        </el-button>
      </el-col>
    </el-row>
    <el-row
        type="flex"
        align="middle"
        justify="start"
        class="table-con"
        v-for="(item, i) in list"
        :key="i"
        @click.native="openDetail(i)"
    >
      <el-col :span="12" class="post-info">
        <div class="post-name">
          <span style="margin-right:15px;">{{ item.task_title }}</span>
          <span class="post-salary" style="margin-right:8px;">
              {{ item.price / 100 }}元
            </span>
          <!--          <el-tag size="small" style="color: #ffffff" :color="item.is_acting == 1?'#87d068':'#02A7F0'">
                      {{ item.is_acting == 1 ? '平台代发' : '企业发布' }}
                    </el-tag>-->

        </div>
        <div style="display: flex;flex-direction: row;margin-top: 5px;align-items: center;">
          <el-progress style="width:200px;margin-right: 10px;" color="#70B603" class="myprogress" :stroke-width="14" :percentage="item.percend"
                       :show-text="false"></el-progress>
          <span style="font-size: 12px;">{{ item.percend == 100 ? '已完成' : '完成' + item.completed + ' / ' + item.amount }}</span>
        </div>
        <div class="info-list">
          <span>剩余金额￥{{ item.left_fee / 100 }}</span>
          <el-tooltip class="item" effect="dark" placement="top-end">
            <template #content>
              任务总额 &nbsp;&nbsp;&nbsp;&nbsp; ￥{{ parseFloat(item.total_fee / 100) }}<br/><br/>
              已消耗 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              ￥{{ accSub(item.total_fee,item.left_fee) / 100 }}<br/><br/>
              剩余金额 &nbsp;&nbsp;&nbsp;&nbsp; ￥{{ parseFloat(item.left_fee / 100) }}
            </template>
            <el-button style="color: #000000" type="text"><i class="el-icon-warning"></i></el-button>
          </el-tooltip>
        </div>
        <div class="info-list">
          <span>任务ID：{{ item.task_no }}</span>
        </div>
      </el-col>
      <el-col :span="12" class="operation">
        <el-button v-if="params.status=='10'" style="margin-bottom: 20px" type="primary" @click.stop="toexamine(i)">
          <i class="el-icon-document"></i>
          审核
        </el-button>
        <el-button v-else style="margin-bottom: 38px" type="primary" @click.native.stop="toCheck(item)">
          <i class="el-icon-document"></i>
          任务单审核
        </el-button>

        <div class="info-list" v-if="params.status=='20'">
          <i class="el-icon-view"></i>
          <span @click.stop="preview(i)">预览</span>
          <el-divider direction="vertical"></el-divider>
          <!-- <i class="el-icon-sort-up"></i>
          <span @click.stop="goup(i)">提价</span>
          <el-divider direction="vertical"></el-divider>
          <i class="el-icon-plus"></i>
          <span @click.stop="showadd(i)">增加名额</span>
          <el-divider direction="vertical"></el-divider> -->
          <i class="el-icon-video-pause"></i>
          <span @click.stop="suspend(i)">暂停</span>
          <el-divider direction="vertical"></el-divider>
          <i class="el-icon-switch-button"></i>
          <span @click.stop="getend(i)">结束</span>
        </div>

        <div class="info-list" v-if="params.status=='40'">
          <i class="el-icon-view"></i>
          <span @click.stop="preview(i)">预览</span>
          <el-divider direction="vertical"></el-divider>
          <i class="el-icon-sort-up"></i>
          <span @click.stop="goup(i)">提价</span>
          <el-divider direction="vertical"></el-divider>
          <i class="el-icon-plus"></i>
          <span @click.stop="showadd(i)">增加名额</span>
          <el-divider direction="vertical"></el-divider>
          <i class="el-icon-caret-right"></i>
          <span @click.stop="start(i)">开启</span>
          <el-divider direction="vertical"></el-divider>
          <i class="el-icon-switch-button"></i>
          <span @click.stop="getend(i)">结束</span>
        </div>

        <div class="info-list" v-if="params.status=='50'">
          <i class="el-icon-view"></i>
          <span @click.stop="preview(i)">预览</span>
          <el-divider direction="vertical"></el-divider>
          <!--          <i class="el-icon-video-play"></i>-->
          <!--          <span @click.stop="goonline(i)">上线</span>-->
          <!--          <el-divider direction="vertical"></el-divider>-->
          <i class="el-icon-refresh"></i>
          <span @click.stop="release(item)">再次发布</span>
          <template v-if="item.left_fee !=0">
            <el-divider direction="vertical"></el-divider>
            <i class="el-icon-scissors"></i>
            <span @click.stop="unFreeze(item)">解冻金额</span>
          </template>
        </div>
      </el-col>
    </el-row>
    <div class="no-data" v-if="!list.length">
      <img src="../../../../assets/null_data.png" alt="">
    </div>
    <el-row type="flex" align="middle" justify="end" :style="{ padding: '30px 0' }">
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </el-row>
    <!--    手机预览-->
    <el-dialog title="手机预览" :visible="dialogTableVisible" @close="dialogTableVisible=false" width="850px">
      <mobile-preview :order_id="order_id"></mobile-preview>
    </el-dialog>
    <!--    提价-->
    <el-dialog title="提价" :visible="shou_goup" @close="shou_goup=false;form_goup.range=''">
      <el-form ref="form" :model="form_goup" label-width="auto">
        <el-form-item>
          {{ '目前单价' + form_goup.univalent + '元，总任务份数' + form_goup.copies + '份，剩余名额' + form_goup.people + '人' }}
        </el-form-item>
        <el-form-item label="提价幅度">
          <el-select v-model="form_goup.range" placeholder="请选择提价幅度" @change="changrang">
            <el-option label="10%" value="10"></el-option>
            <el-option label="25%" value="25"></el-option>
            <el-option label="30%" value="30"></el-option>
            <el-option label="45%" value="45"></el-option>
            <el-option label="60%" value="60"></el-option>
            <el-option label="75%" value="75"></el-option>
            <el-option label="100%" value="100"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提价后金额">
          <span style="color: #6BD4CB">{{
              form_goup.amount
            }}</span> 元
        </el-form-item>
        <el-form-item>
          {{ '提价' + form_goup.price + '元，需补充金额' + form_goup.supplement + '元' }}
        </el-form-item>
        <el-form-item>
          <p style="color: #F59E2B">注：单价一旦增加不可减少哦~</p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="form_goupSubmit">完成</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--    增加名额-->
    <el-dialog title="增加名额" :visible="shou_quota" @close="shou_quota=false;form_quota.addpeo=0">
      <el-form ref="form" :model="form_quota" label-width="auto">
        <el-form-item>
          {{ '总名额' + form_quota.totalquota + '人，目前剩余' + form_quota.surplus + '人，单价' + form_quota.price + '元' }}
        </el-form-item>
        <el-form-item label="增加名额">
          <el-input-number v-model="form_quota.addpeo" @change="addpeoChange" :min="0" :max="99999"
                           label="增加名额"></el-input-number>
        </el-form-item>
        <el-form-item label="需补充金额">
          <span style="color: #FF787F">{{ form_quota.amount }} 元</span>
        </el-form-item>
        <el-form-item>
          <p style="color: #F59E2B">注：名额一旦增加不可减少哦~</p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="form_quotaSubmit">完成</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--    详情-->
    <el-drawer
        :visible.sync="drawer"
        size="1100"
        :with-header="false"
    >
      <el-row
          type="flex" align="middle" justify="end"
          style="paddingbottom: 40px"
      >
        <el-col style="cursor: pointer">
          <icon-font type="guanbi" :style="{ fontSize: '19px' }" @click="drawer = !drawer"/>
        </el-col>
        <el-col style="cursor: pointer">
          <span @click="viewDetail"><a-icon type="fullscreen"/>在新窗口打开</span>

        </el-col>
      </el-row>
      <job-detail @adopt="adopt" :order_id="order_id" :examine="examine"></job-detail>
    </el-drawer>
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import {Decimal} from 'decimal.js'
import Api from "@/api";
import Pagination from "@/components/Pagination";
import baseComponentVue from "../../../../components/base-component.vue";
import "../../../../shared/plugins/element"
import JobDetail from "./jobTaskDetail";
import MobilePreview from "./mobilePreview";

export default {
  name: "post",
  extends: baseComponentVue,
  data() {
    return {
      order_id: undefined,
      content: {
        title: "",
        price: "",
        text: "",
        introduce: "",
      },
      examine: false,
      params: {
        company_name: "",
        releasemode: "",
        status: "20",
        is_acting: '', //发布类型
      },
      tabs: [
        {
          text: "进行中",
          key: "20"
        },
        {
          text: "待审核",
          key: "10"
        },
        {
          text: "暂停中",
          key: "40"
        },
        {
          text: "已结束",
          key: "50"
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
      },
      created_time: [],
      total: 0,
      loading: true,
      list: [],
      basic_salary_period: ['', '小时', '天', '周', '月', '次', '其他'],
      dialogTableVisible: false,
      shou_goup: false,
      shou_quota: false,
      form_goup: {
        univalent: "",
        copies: "",
        people: "",
        price: "",
        range: "",
        supplement: "",
        amount: "0",
      },
      form_quota: {
        totalquota: "",
        surplus: "",
        price: "",
        addpeo: 0,
        amount: 0
      },
      drawer: false,
      resizeOffset: 0,
      screenWidth: 0
    };
  },
  watch: {
    screenWidth: {
      immediate: true,
      handler(newValue) {
        console.log(this.resizeOffset)
        console.log(newValue)
        if (newValue > 1640) {
          this.resizeOffset = 0;
        }
        if (newValue > 1470 && newValue < 1640) {
          this.resizeOffset = 1;
        }
        if (newValue > 1370 && newValue < 1470) {
          this.resizeOffset = 2;
        }
        if (newValue > 1000 && newValue < 1370) {
          this.resizeOffset = 3;
        }
      }
    }
  },
  created() {
    this.loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    window.addEventListener("resize", () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        this.screenWidth = window.screenWidth;
      })();
    });
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState(['user'])
  },
  components: {Pagination, JobDetail, MobilePreview},
  methods: {
    goonline() {

    },
    accSub (arg1, arg2){
      let r1, r2, m, n
      try { r1 = arg1.toString().split('.')[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split('.')[1].length } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2))
      n = (r1 >= r2) ? r1 : r2
      return ((arg1 * m - arg2 * m) / m).toFixed(n)
    },
    //再次发布
    async release(item) {
      try {
        let params = {
          id: item.id
        }
        let res = await Api.post.duplicatey(params);
        this.$router.push({path: '/jobTask/publish-task', query: {id: res.id}});
      } catch (e) {
        this.$message({
          type: 'error',
          message: '发布失败!'
        });
      }
    },
    //解冻资金
    unFreeze(item) {
      this.$confirm('确定要解冻金额?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          let params = {
            id: item.id
          }
          let res = await Api.post.unfreeze(params);
          this.getData(this.pagination);
          this.$message({
            type: 'success',
            message: '解冻成功!'
          });
        } catch (e) {
          this.$message({
            type: 'error',
            message: '解冻失败!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解冻资金操作'
        });
      });

    },
    start(idx) {
      this.$confirm('确定要开启该任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          Api.post.moneystar({
            id: this.list[idx].id
          }).then(() => {
            this.getData(this.pagination);
            this.$message({
              type: 'success',
              message: '开启成功!'
            });
          });
        } catch (e) {
          console.log(e)
          this.$message.error('请检查网络');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消开启操作'
        });
      });
    },
    adopt() {
      this.examine = false;
      this.getData(this.pagination);
    },
    toexamine(idx) {
      this.order_id = this.list[idx].id;
      this.drawer = true;
      this.examine = true
    },
    addpeoChange(e) {
      this.form_quota.amount = new Decimal(this.form_quota.price).mul(new Decimal(e));
      console.log(this.form_quota.amount)
    },
    async form_quotaSubmit() {
      if (this.form_quota.addpeo) {
        let params = {
          id: this.order_id,
          amount: this.form_quota.addpeo,
          agreed: 1
        }
        try {
          await Api.post.addamount(params).then(res => {
            this.$message({
              message: '增加名额成功',
              type: 'success'
            });
            this.shou_quota = false;
            this.form_quota.addpeo = 0;
            this.getData(this.pagination);
          });
        } catch (err) {
          this.$message.error('请检查网络');
        }
      } else {
        this.$message({
          message: '请输入增加名额',
          type: 'warning'
        });
      }
    },
    async form_goupSubmit() {
      if (this.form_goup.range) {
        let params = {
          id: this.order_id,
          percent: this.form_goup.range,
          agreed: 1
        }
        try {
          await Api.post.raiseprice(params).then(res => {
            this.$message({
              message: '提价成功',
              type: 'success'
            });
            this.shou_goup = false;
            this.form_goup.range = '';

            this.getData(this.pagination);
          });
        } catch (err) {
          this.$message.error('请检查网络');
        }
      } else {
        this.$message({
          message: '请选择提价幅度',
          type: 'warning'
        });
      }
      console.log(this.form_goup.range)
    },
    openDetail(idx) {
      this.order_id = this.list[idx].id;
      this.examine = false;
      this.drawer = true;
    },
    viewDetail(record) {
      this.drawer = false;
      let resolveDRoute = this.$router.resolve({
        path: `/money-task/detail/${this.order_id}`,
      });
      window.open(resolveDRoute.href, "_blank");
    },
    getend(idx) {
      this.$confirm('任务结束后任务单仍可进行审核', '确认要结束该任务？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          Api.post.moneyoffline({
            id: this.list[idx].id
          }).then(() => {
            this.getData(this.pagination);
            this.$message({
              type: 'success',
              message: '已结束!'
            });
          });
        } catch (e) {
          console.log(e)
          this.$message.error('请检查网络');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消结束操作'
        });
      });
    },
    suspend(idx) {
      this.$confirm('确定要暂停该任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          Api.post.moneypause({
            id: this.list[idx].id
          }).then(() => {
            this.getData(this.pagination);
            this.$message({
              type: 'success',
              message: '暂停成功!'
            });
          });
        } catch (e) {
          console.log(e)
          this.$message.error('请检查网络');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消暂停操作'
        });
      });
    },
    showadd(idx) {
      this.order_id = this.list[idx].id;
      this.form_quota.totalquota = this.list[idx].amount;
      this.form_quota.surplus = this.list[idx].left_amount;
      this.form_quota.price = new Decimal(this.list[idx].price).div(new Decimal(100));

      this.shou_quota = true;
    },
    changrang() {
      console.log(this.form_goup.range)
      this.form_goup.amount = new Decimal(this.form_goup.univalent).add(new Decimal(new Decimal(this.form_goup.univalent).mul(new Decimal(new Decimal(this.form_goup.range).div(new Decimal(100))))));
      this.form_goup.price = new Decimal(this.form_goup.univalent).mul(new Decimal(new Decimal(this.form_goup.range).div(new Decimal(100))));
      this.form_goup.supplement = new Decimal(this.form_goup.people).mul(new Decimal(this.form_goup.univalent)).mul(new Decimal(new Decimal(this.form_goup.range).div(new Decimal(100))));
    },
    goup(idx) {
      this.order_id = this.list[idx].id;
      this.form_goup.univalent = new Decimal(this.list[idx].price).div(new Decimal(100));
      this.form_goup.copies = this.list[idx].amount;
      this.form_goup.people = this.list[idx].left_amount;
      this.shou_goup = true;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pagination.current = val;
      this.getData(this.pagination);
    },
    handleClick(tab, event) {
      console.log(tab, event)
      this.getData();
    },
    preview(idx) {
      this.order_id = this.list[idx].id;
      this.dialogTableVisible = true
      console.log(123)
    },
    ...mapMutations(["toggleJobView"]),
    resetParams() {
      this.created_time = null;
      this.params = {
        status: '20',
        company_name: "",
        is_acting: '',
      };
    },
    async getData(pagination, filters, sorter) {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      console.log(this.created_time);
      if (pagination) {
        let pager = {...this.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }
      let params = {
        ...this.params,
        release_type: this.params.releasemode,
        company: this.params.company_name,
        start: this.created_time ? this.created_time[0] : null,
        end: this.created_time ? this.created_time[1] : null,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };
      if (params.is_acting === '') {
        delete params.is_acting
      }
      try {
        var response = await Api.post.getMoneyList(params);
        this.total = +response.total;
        this.list = response.list;
      } catch (err) {
        this.loading.close();
      }
      this.loading.close();
      document.querySelector(".inner").scrollTop = 0; // 获取数据后页面滚动到顶部
    },
    addPost() {
      this.$router.push({
        path: `/jobTask/publish-task`,
      });
    },
    toCheck(item) {
      this.$router.push({
        path: `/post-money-task`,
        name: "moneytask",
        query: {
          task_title: item.task_title,
          company_name: item.company_name,
          id: item.id
        }
      });
    }

  }
};
</script>

<style scoped lang="scss">
.post {
  .sort-bar {
    text-align: center;
    margin-top: 11px;
    border-radius: 3px;
    border: 1px solid rgba(228, 232, 235, 1);

    .sort {
      cursor: pointer;
      height: 58px;
      line-height: 58px;
      color: #909399;

      &.active {
        color: #5ec9ff;
      }
    }
  }

  .table-con {
    margin-top: 11px;
    border-radius: 8px;
    border: 1px solid #666;
    padding: 20px;
    text-align: left;
  }

  .post-info {
    /*display: block;*/
    /*display: -webkit-box;*/
    /*-webkit-box-orient: vertical;*/
    /*-webkit-line-clamp: 1;*/
    /*overflow: hidden;*/
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
    /*padding-right: 20px;*/

    div {
      display: flex;
      align-items: center;
    }

    .ji {
      display: block;
      background: red;
      padding: 1px 6px;
      border-radius: 10px;
      margin-left: 10px;
      color: white;
      font-size: 10px;
      font-weight: 400;
    }

    .duo {
      display: block;
      background: deepskyblue;
      padding: 1px 6px;
      border-radius: 10px;
      margin-left: 10px;
      color: white;
      font-size: 10px;
      font-weight: 400;
    }

    .post-name {
      font-weight: bold;

      .info-list {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-right: 20px;
      }
    }
  }

  .post-salary {
    color: red;
    font-size: 19px;
  }

  .operation {
    padding-left: 15px;
    text-align: right;

    div {
      color: deepskyblue;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .marriage-select {
    width: 100%;
  }

  .half-page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;

    .content {
      margin-left: 50%;
      width: 50%;
      height: 100%;
      overflow: auto;
      background: #fff;
      box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.16);
      padding: 30px 40px;

      .close {
        cursor: pointer;
      }

      .new_win {
        cursor: pointer;
        color: #999;
        display: flex;
        align-items: center;

        .anticon {
          font-size: 16px;
          margin-right: 6px;
        }
      }
    }
  }

  .no-data {
    width: 100%;
    padding: 20px 0;
    color: #9b9b9b;
    border-bottom: 1px solid #e4e8eb;
    text-align: center;
  }
  ::v-deep .el-progress-bar{
    padding-right: 0px!important;
  }
  ::v-deep .myprogress{
    margin-top: 0px!important;
    margin-bottom: 0px!important;
  }
}
</style>
